// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"location-enlargement"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20 10C20 16.5 12 22 12 22C12 22 4 16.4992 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20 10C20 16.5 12 22 12 22C12 22 4 16.4992 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9 10.5H12M12 10.5H15M12 10.5V7.5M12 10.5V13.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-location-enlargement')
export default class LocationEnlargementIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'location-enlargement',
    }
  }
}
